export default "__VITE_ASSET__DwbBII4U__"